import { render, staticRenderFns } from "./SelectBankType.vue?vue&type=template&id=1b2b3f43&lang=pug"
import script from "./SelectBankType.vue?vue&type=script&lang=js"
export * from "./SelectBankType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports